import api from "../services/api";

export default {
  namespaced: true,
  actions: {
    getApiCallsReport: async ({ commit }, payload) => {
      const response = await api.getReport("api-calls", payload);
      return response.data;
    },
    getBillingReport: async ({ commit }, payload) => {
      const response = await api.getReport("billing",payload);
      return response.data;
    },
  },
};
